// extracted by mini-css-extract-plugin
module.exports = {"container":"nC-z","links":"oC-z"};